import React from 'react';
import { Star } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    name: 'Mariana L.',
    text: 'Nunca había hecho nada manual. Las explicaciones son tan claras que mi primera maceta quedó perfecta. ¡Ya me hicieron mi primer pedido!',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&auto=format&fit=crop'
  }, {
    name: 'Carolina S.',
    text: 'Había gastado mucho en moldes y cemento que se me rompía. Con la fórmula de Camila por fin logré piezas lisas y sin burbujas. 100% recomendado.',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=150&auto=format&fit=crop'
  }, {
    name: 'Julieta M.',
    text: 'Es una terapia hermosa. Llego del trabajo y me pongo a crear. El curso es súper completo y los bonos de color me encantaron.',
    img: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=150&auto=format&fit=crop'
  }];
  return <section className="py-24 bg-sand-50 bg-terrazzo relative" data-id="element-295">
      <div className="container mx-auto px-4 relative z-10" data-id="element-296">
        <div className="text-center mb-16" data-id="element-297">
          <span className="text-sage-600 text-xs font-bold tracking-widest uppercase mb-4 block" data-id="element-298">
            Testimonios
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-concrete-900" data-id="element-299">
            Lo que dicen nuestras alumnas
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-300">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-8 md:p-10 rounded-[2rem] border border-sand-200 shadow-sm hover:shadow-premium transition-shadow duration-300 relative" data-id="element-301">
              <div className="absolute top-8 right-8 text-sand-200" data-id="element-302">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-303">
                  <path d="M14.017 21L16.41 14.182C16.614 13.591 16.716 12.966 16.716 12.307C16.716 10.966 16.273 9.875 15.386 9.034C14.5 8.193 13.352 7.773 11.943 7.773V3C14.284 3 16.273 3.795 17.909 5.386C19.545 6.977 20.364 8.966 20.364 11.352C20.364 12.557 20.148 13.739 19.716 14.898L17.159 21H14.017ZM4.653 21L7.045 14.182C7.25 13.591 7.352 12.966 7.352 12.307C7.352 10.966 6.909 9.875 6.023 9.034C5.136 8.193 3.989 7.773 2.58 7.773V3C4.92 3 6.909 3.795 8.545 5.386C10.182 6.977 11 8.966 11 11.352C11 12.557 10.784 13.739 10.352 14.898L7.795 21H4.653Z" data-id="element-304" />
                </svg>
              </div>

              <div className="flex gap-1 mb-6" data-id="element-305">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-400 text-gold-400" data-id="element-306" />)}
              </div>

              <p className="text-concrete-700 font-light leading-relaxed italic mb-8 relative z-10" data-id="element-307">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-308">
                <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-sand-100" data-id="element-309" />
                <span className="font-medium text-concrete-900" data-id="element-310">{t.name}</span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}